import { render } from "./ConnectionsSettingsViewDataset.vue?vue&type=template&id=20874fec"
import script from "./ConnectionsSettingsViewDataset.vue?vue&type=script&lang=js"
export * from "./ConnectionsSettingsViewDataset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/ConnectionsSettingsViewDataset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20874fec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20874fec', __exports__)) {
    api.reload('20874fec', __exports__)
  }
  
  module.hot.accept("./ConnectionsSettingsViewDataset.vue?vue&type=template&id=20874fec", () => {
    api.rerender('20874fec', render)
  })

}


export default __exports__